var _path, _g, _path2, _path3, _path4, _path5, _path6, _path7, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyViewIllustration(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 401 431",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M200.5 401C311.233 401 401 311.233 401 200.5C401 89.7669 311.233 0 200.5 0C89.7669 0 0 89.7669 0 200.5C0 311.233 89.7669 401 200.5 401Z",
    fill: "url(#paint0_linear_2_5)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2_5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M315.453 114.953H85.5467C78.1645 114.953 72.1801 120.938 72.1801 128.32V409.02C72.1801 416.402 78.1645 422.387 85.5467 422.387H315.453C322.836 422.387 328.82 416.402 328.82 409.02V128.32C328.82 120.938 322.836 114.953 315.453 114.953Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M173.767 155.053H104.26C99.8307 155.053 96.24 158.644 96.24 163.073C96.24 167.503 99.8307 171.093 104.26 171.093H173.767C178.196 171.093 181.787 167.503 181.787 163.073C181.787 158.644 178.196 155.053 173.767 155.053Z",
    fill: "#B4DAFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M221.887 189.807H104.26C99.8307 189.807 96.24 193.397 96.24 197.827C96.24 202.256 99.8307 205.847 104.26 205.847H221.887C226.316 205.847 229.907 202.256 229.907 197.827C229.907 193.397 226.316 189.807 221.887 189.807Z",
    fill: "#DFEAFB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M173.767 227.233H104.26C99.8307 227.233 96.24 230.824 96.24 235.253C96.24 239.683 99.8307 243.273 104.26 243.273H173.767C178.196 243.273 181.787 239.683 181.787 235.253C181.787 230.824 178.196 227.233 173.767 227.233Z",
    fill: "#B4DAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M221.887 261.987H104.26C99.8307 261.987 96.24 265.577 96.24 270.007C96.24 274.436 99.8307 278.027 104.26 278.027H221.887C226.316 278.027 229.907 274.436 229.907 270.007C229.907 265.577 226.316 261.987 221.887 261.987Z",
    fill: "#DFEAFB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M173.767 299.413H104.26C99.8307 299.413 96.24 303.004 96.24 307.433C96.24 311.863 99.8307 315.453 104.26 315.453H173.767C178.196 315.453 181.787 311.863 181.787 307.433C181.787 303.004 178.196 299.413 173.767 299.413Z",
    fill: "#B4DAFF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M221.887 334.167H104.26C99.8307 334.167 96.24 337.757 96.24 342.187C96.24 346.616 99.8307 350.207 104.26 350.207H221.887C226.316 350.207 229.907 346.616 229.907 342.187C229.907 337.757 226.316 334.167 221.887 334.167Z",
    fill: "#DFEAFB"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2_5",
    x: 56.1401,
    y: 90.8933,
    width: 288.72,
    height: 339.513,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -8.02
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.02
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2_5"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2_5",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2_5",
    x1: 200.5,
    y1: 0,
    x2: 200.5,
    y2: 401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E3ECFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE7FF"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyViewIllustration);
export default __webpack_public_path__ + "static/media/empty-view-illustration.776a1da3.svg";
export { ForwardRef as ReactComponent };